import provider from './provider';
import container from './container';

export default { provider, container };
